import { AuditSale } from "src/app/ui/models/domains/pbm/audit/audit-sale/audit-sale";
import { AuditSaleDetails } from "src/app/ui/models/domains/pbm/audit/audit-sale/audit-sale-details";
import { UniqueSequentialNumber } from "src/app/ui/models/domains/pbm/financial-satatement/unique-sequential-number";
import { PageableResult } from "../../../../models/domains/paginator/pageable-result";
import { parseBeneficiary } from "../beneficiary/beneficiary-parse-functions";
import { NetworkParser } from "../benefit/network.parser";
import { parseProductItems } from "../transaction-management/transaction-management-parse-functions";

const pageableResult = new PageableResult();
export function parseAuditSalePageableResult(payload: any): PageableResult {
  pageableResult.setStart(payload.Start);
  pageableResult.setEnd(payload.TotalPerPages);
  pageableResult.setTotalItems(payload.Total);
  pageableResult.setItems(parseAuditSaleList(payload.Data));
  return pageableResult;
}

export function parseAuditSale(payload: any): AuditSale {
  const auditSale = new AuditSale();
  if (payload) {
    const networkParser = new NetworkParser();

    auditSale.setSalesOrderKey(payload.SalesOrderKey);

    const uniqueSequentialNumber = new UniqueSequentialNumber();
    uniqueSequentialNumber.setValue(payload.UniqueSequentialNumber.Value);
    auditSale.setUniqueSequentialNumber(uniqueSequentialNumber);

    const uniqueSequentialNumberCorrelated = new UniqueSequentialNumber();
    uniqueSequentialNumberCorrelated.setValue(payload.UniqueSequentialNumberCorrelated ? payload.UniqueSequentialNumberCorrelated.Value : null);
    auditSale.setUniqueSequentialNumberCorrelated(uniqueSequentialNumberCorrelated);

    const beneficiary = parseBeneficiary(payload.Beneficiary);
    auditSale.setBeneficiary(beneficiary);

    auditSale.setTransactionDate(payload.TransactionDate);
    auditSale.setSalesAction(payload.SalesAction);

    const network = networkParser.parseUnicNetwork(payload.NetworkInfo);
    auditSale.setNetworkInfo(network);

    auditSale.setErrorCauses(payload.ErrorCauses);
    auditSale.setStatus(payload.Status);
    auditSale.setSource(payload.Source);
    auditSale.setHasPendingMedicalPrescriptionScans(payload.HasPendingMedicalPrescriptionScans);
  }
  return auditSale;
}

export function parseAuditSaleList(payload: Array<any>): Array<AuditSale> {
  const auditSaleList: Array<AuditSale> = payload.map((item) => {
    return parseAuditSale(item);
  });
  return auditSaleList;
}

/**
 * Como a classe AuditSaleDetails estende de AuditSale foi usado o mesmo parse para as propriedades herdadas
 * e apenas adicionado o parse da propriedade "items"
 * @param payload dever chegar um JSON no formato de AuditSaleDetails
 * @returns AuditSaleDetails
 */
export function parseAuditSaleDetails(payload: any): AuditSaleDetails {
  let auditSaleDetails = new AuditSaleDetails();
  if (payload) {
    auditSaleDetails.setAuditSaleProperts(parseAuditSale(payload));
    auditSaleDetails.setItems(parseProductItems(payload.Items));
  }
  return auditSaleDetails;
}
